export default __webpack_public_path__ + "static/media/playgameworks.c35e126a.png";